module.exports = __webpack_public_path__ + "static/img/p1.0bb05b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/a-view-outside/p1.png
// module id = efSF
// module chunks = 0